.banner {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  min-height: 3.2rem;
  background: var(--color-secondary-roman);

  & svg {
    width: 2rem;
    color: white;
  }

  & > a {
    position: absolute;
    right: 1.6rem;
    color: white;
    font-size: 1.4rem;
    margin: 0.8rem 0;

    &:hover {
      text-decoration: underline;
    }
  }

  & > div {
    display: flex;
    gap: 0.8rem;
    align-items: center;
  }

  @media screen and (min-width: $bp-medium) {
    display: flex;
    flex-direction: row;
  }
}

.text {
  color: var(--color-grayscale-white);
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.4rem;

  & > span {
    display: none;
  }

  @media screen and (min-width: $bp-medium) {
    & > span {
      display: inline;
    }
  }
}
